import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { logout } from 'actions';
import _ from 'lodash';
import { showUpgradeModal } from 'reducers/featureRestrictions/actions';
import styles from './NavLoggedIn.css';

class NavLoggedIn extends React.Component {
  render() {
    const { subMenuOf, user } = this.props;
    return (
      <div
        className={`navbar-collapse collapse header-login ${styles.wrapper}`}
        id="NavLoggedIn"
      >
        <ul className="nav navbar-nav nav-outlet-dekstop-dropdown mk-navbar-nav navbar-right pull-right visible-md visible-lg">
          <li className="dropdown">
            <Link
              to="#"
              className="dropdown-toggle"
              data-toggle="dropdown"
              role="button"
            >
              <i className="glyphicon glyphicon-user" />
              <span className="fa fa-angle-down" />
            </Link>
            <ul
              className="dropdown-menu mk-short-profile-dropdown info-width"
              role="menu"
            >
              <li className="mk-short-profile">
                <div className="avatar">
                  <img
                    src={
                      !user.gravatar
                        ? require('assets/images/account-profile-default.jpg')
                        : user.gravatar
                    }
                    alt="account profile default"
                  />
                </div>
                <div className="mk-business-info">
                  <div className="business-name gt">
                    {user.first_name} {user.last_name}
                  </div>
                  <div className="business-email">{user.email}</div>
                </div>
                <div className="clearfix" />
              </li>
              <li className="divider" />
              <li>
                <Link to="/settings/accounts">Account Settings</Link>
              </li>
              <li className="divider" />
              <li>
                <Link to="#" onClick={this._logout}>
                  <i className="fa fa-sign-out" />
                  Logout
                </Link>
              </li>
            </ul>
          </li>
        </ul>
        <ul className="nav nav-outlet-dekstop navbar-nav mk-navbar-nav uppercase visible-md visible-lg">
          {subMenuOf.dashboard && this._getNav('dashboard')}
          {subMenuOf.reports && this._getNav('reports')}
          {subMenuOf.library && this._getNav('library')}
          {subMenuOf.ingredient && this._getNav('ingredient')}
          {subMenuOf.inventory && this._getNav('inventory')}
          {subMenuOf.customers && this._getNav('customers')}
          // {subMenuOf.employees && this._getNav('employees')}
          {subMenuOf.outlets && this._getNav('outlets')}
        </ul>
        <ul className="nav navbar-nav mk-navbar-nav uppercase visible-xs visible-sm text-center full-width">
          {subMenuOf.dashboard && this._getNavMobileView('dashboard')}
          {subMenuOf.reports && this._getNavMobileView('reports')}
          {subMenuOf['account settings'] &&
            this._getNavMobileView('account settings')}
          {subMenuOf.capital && this._getNavMobileView('capital')}
          {subMenuOf.apps && this._getNavMobileView('apps')}
          {subMenuOf['moka fresh'] && this._getNavMobileView('moka fresh')}
          <li>
            <Link to="#" onClick={this._logout}>
              <i className="fa fa-sign-out" />
              Logout
            </Link>
          </li>
        </ul>
      </div>
    );
  }

  _getNav = name => {
    const {
      location,
      subMenuOf,
      user: { business },
    } = this.props;
    const backOfficemenus = _.filter(subMenuOf, function(o) {
      return o[0].access === 'Back-office';
    });
    const menuHashes = _.map(backOfficemenus, bom => ({
      menu: bom[0].menu,
      priority_rank: bom[0].priority_rank,
      isLocked:
        business.is_mokapay_user && bom.every(m => !m.is_allowed_for_moka_pay),
    }));
    const menu = _.find(menuHashes, o => {
      return o.menu.toLowerCase() === name.toLowerCase();
    });
    const path = location.pathname;
    const firstSubNav = this._getFirstSubNav(subMenuOf[name]);
    if (menu.isLocked) {
      return (
        <li className="disabled">
          <Link
            className={
              path.startsWith(`/${name}`) || path === '/'
                ? 'active has-icon'
                : 'has-icon'
            }
            onClick={this.onLockedItemClick}
          >
            <span className="glyphicon glyphicon-lock" />
            {name}
          </Link>
        </li>
      );
    }
    return (
      <li>
        <Link
          className={
            path.startsWith(`/${name}`) || path === '/' ? 'active' : ''
          }
          to={firstSubNav}
        >
          {name}
        </Link>
      </li>
    );
  };

  _getNavMobileView = name => {
    const {
      location,
      subMenuOf,
      user: { business },
    } = this.props;
    const backOfficemenus = _.filter(subMenuOf, function(o) {
      return o[0].access === 'Back-office';
    });
    const menuHashes = _.map(backOfficemenus, bom => ({
      menu: bom[0].menu,
      priority_rank: bom[0].priority_rank,
      isLocked:
        business.is_mokapay_user && bom.every(m => !m.is_allowed_for_moka_pay),
    }));
    const menu = _.find(menuHashes, o => {
      return o.menu.toLowerCase() === name.toLowerCase();
    });
    const path = location.pathname;
    if (menu.isLocked) {
      return (
        <li className="disabled">
          <Link
            className={
              path.startsWith(`/${name}`) || path === '/'
                ? 'active has-icon'
                : 'has-icon'
            }
            data-toggle="collapse"
            data-target=".navbar-collapse"
            onClick={this.onLockedItemClick}
          >
            <span className="glyphicon glyphicon-lock" />
            {name}
          </Link>
        </li>
      );
    }
    return (
      <li>
        <Link
          className={
            path.startsWith(`/${name}`) || path === '/' ? 'active' : ''
          }
          to={this._getFirstSubNav(subMenuOf[name])}
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          {name}
        </Link>
      </li>
    );
  };

  _getFirstSubNav = permissions => {
    return _.orderBy(permissions, 'priority_rank')[0].urls[0];
  };

  onLockedItemClick = () => {
    this.props.dispatch(showUpgradeModal());
  };

  _logout = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.dispatch(logout());
  };
}

function mapStateToProps(state) {
  const { permissions, user } = state.moka;

  // A very strange way to generate sidebar items
  const subMenuOf = _.groupBy(permissions, permission =>
    permission.menu.toLowerCase()
  );

  return {
    subMenuOf,
    user,
  };
}

export default connect(mapStateToProps)(NavLoggedIn);
